export const splitAddress = function (address) {

    let streetNumber = "";
    let streetName = address;
    let index = address.indexOf(" ");
    if (index > 0) {
        streetNumber = address.substring(0, index);
        streetName = address.substring(index + 1);
    }

    return {
        streetNumber: streetNumber,
        streetName: streetName
    };
}